/*
  Promo callout + subscription upsell (snippets/izo-promo-callout.liquid,
  blocks/izo-subscription-upsell.liquid).

  Liquid decides what to render. This only removes a callout from pages cached past
  its end time, and reports upsell clicks.

  [data-promo-window] (the callout) carries data-starts-at / data-ends-at as epoch
  milliseconds, either of which may be absent (no limit on that side). It is removed
  once outside its window.

  Loaded by both blocks, so it guards against running twice.
*/
(() => {
  if (window.__izoPromoCallouts) return;
  window.__izoPromoCallouts = true;

  // setTimeout stores its delay as a signed 32-bit integer; longer overflows and fires at once.
  const MAX_DELAY = 2 ** 31 - 1;

  const inWindow = (el, now) => {
    const starts = el.dataset.startsAt ? Number(el.dataset.startsAt) : -Infinity;
    const ends = el.dataset.endsAt ? Number(el.dataset.endsAt) : Infinity;
    return now >= starts && now < ends;
  };

  const apply = (el) => {
    if (!inWindow(el, Date.now())) el.remove();
  };

  const nextBoundary = (el, now) => {
    const times = [el.dataset.startsAt, el.dataset.endsAt]
      .filter(Boolean)
      .map(Number)
      .filter((t) => t > now);
    return times.length ? Math.min(...times) : null;
  };

  const watch = (el) => {
    if (el.dataset.promoWatched) return;
    el.dataset.promoWatched = 'true';

    const tick = () => {
      if (!el.isConnected) return;
      apply(el);
      if (!el.isConnected) return;
      const next = nextBoundary(el, Date.now());
      if (next !== null) setTimeout(tick, Math.min(next - Date.now(), MAX_DELAY));
    };
    tick();
  };

  const init = () => document.querySelectorAll('[data-promo-window]').forEach(watch);

  // Timers are throttled in background tabs; re-check when the tab comes back.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') document.querySelectorAll('[data-promo-window]').forEach(apply);
  });

  // The theme editor re-renders blocks in place.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);

  // The handle is sent alongside the id because GA4's item_id is the SKU, not the
  // Shopify product id; the handle is what joins this event to a product (see
  // snippets/login-prompt-tooltip.liquid).
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('[data-subscription-upsell-link]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'subscription_upsell_click',
      product_id: link.dataset.productId,
      product_handle: link.dataset.productHandle,
      link_url: link.href,
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
